import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import DataFlowService from '../../services/DataFlow.service';
import Dashboard4 from './Dashboard4';
import Dashboard3 from './Dashboard3';
import Dashboard2 from './Dashboard2';
import Dashboard1 from './Dashboard1';
import UserService from '../../services/UserService';
import Dashboard5 from './Dashboard5';
import Dashboard6 from './Dashboard6';
import RiskAssessmentService from '../../services/RiskAssessment.service';

export default function Dashboard() {
    const { t } = useTranslation();
    const [mDepartment, setMDepartment] = useState([]);
    const [dataRisk, setDataRisk] = useState();

    // Loading
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingDepartment, setIsLoadingDepartment] = useState(false);

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    useEffect(() => {
        getDepartmentList();

        if (admin) {
            getActivityRisk();
        } else {
            getActivityRiskRegister();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getDepartmentList = async () => {
        try {
            setIsLoadingDepartment(true);
            const { data } = await DataFlowService.getDepartmentList();
            if (data?.resultData) {
                setIsLoadingDepartment(false);
                setMDepartment(data.resultData);
            }
        } catch (error) {
            setIsLoadingDepartment(false);
            console.log(error);
        }
    };

    const getActivityRisk = async () => {
        try {
            setIsLoading(true);
            const { data } = await RiskAssessmentService.getActivityRisk();
            if (data?.resultData) {
                setDataRisk(data.resultData);
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
        }
    };

    const getActivityRiskRegister = async () => {
        try {
            setIsLoading(true);
            const { data } =
                await RiskAssessmentService.getActivityRiskRegister();
            if (data?.resultData) {
                setIsLoading(false);
                setDataRisk(data.resultData);
            }
        } catch (error) {
            setIsLoading(false);
            console.log(error);
        }
    };

    return (
        <>
            <div className="title ">
                {t('DashBoardRM.DashboardRiskManagement')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('common.RiskManagement')} /{' '}
                </span>
                <span>{t('DashBoardRM.DashboardRiskManagement')}</span>
            </div>
            <div className="my-6 p-6 bg-white rounded-md">
                <span className="text-xl text-purple">
                    {t('DashBoardRM.DashboardOverview')}
                </span>
            </div>

            <div className="grid grid-cols-12 mt-4">
                <div className="col-span-6 bg-white rounded-md mr-2">
                    <div className="p-6">
                        {admin ? (
                            <Dashboard1
                                dataRisk={dataRisk}
                                isLoading={isLoading}
                            />
                        ) : (
                            <Dashboard5
                                dataRisk={dataRisk}
                                isLoading={isLoading}
                            />
                        )}
                    </div>
                </div>
                <div className="col-span-6 bg-white rounded-md ml-2">
                    <div className="p-6">
                        {admin ? (
                            <Dashboard2
                                dataRisk={dataRisk}
                                isLoading={isLoading}
                            />
                        ) : (
                            <Dashboard6
                                dataRisk={dataRisk}
                                isLoading={isLoading}
                            />
                        )}
                    </div>
                </div>
                {admin && (
                    <>
                        <div className="col-span-12 bg-white rounded-md mt-4">
                            <div className="p-6">
                                <Dashboard3
                                    mDepartment={mDepartment}
                                    isLoading={isLoadingDepartment}
                                />
                            </div>
                        </div>
                        <div className="col-span-12 bg-white rounded-md mt-4">
                            <div className="p-6">
                                <Dashboard4
                                    mDepartment={mDepartment}
                                    isLoading={isLoadingDepartment}
                                />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}
